import styled from 'styled-components';
import { CardMixin } from '../../mixins/components/CardMixin';
export var StyledCard = /*#__PURE__*/styled.div.withConfig({
  displayName: "StyledCard",
  componentId: "c11n-8-107-0__sc-1w6p0lv-0"
})(["", ""], CardMixin);